<div class="st-form">
  <app-st-impersonation-floating-banner [impersonatedEmail]="this.impersonatedEmail"
                                        [username]="this.username"
                                        [roleName]="this.consultantRoleName"
                                        (exitViewAs)="this.onExitViewAs($event)"
  >

  </app-st-impersonation-floating-banner>
</div>

<div id="saved-search-modal-id" class="modal">
  <!-- Modal content -->
  <div class="modal-content">
    <div class="modal-header">
      <span class="close" (click)="closeSavedSearchModal()">&times;</span>
      <br>
      <div *ngIf="showErrorMessages" class="container st-form text-danger" #goUp>
        <app-st-span><b>Please validate the following: </b></app-st-span>
        <div *ngFor="let errorMsg of errorMessages" class="alert alert-danger" role="alert">
          <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
        </div>
        <br>
      </div>
      <div *ngIf="showSuccessMessages" class="container st-form text-success" #goUp>
        <app-st-span><b>Please validate the following: </b></app-st-span>
        <div *ngFor="let successMsg of successMessages" class="alert alert-success" role="alert">
          <b>{{successMsg.field}}:</b> {{successMsg.detail}}
        </div>
        <br>
      </div>
      <br>
    </div>
    <div class="modal-body">
      <app-st-input-text [idVal]="'saved-search-name-text-id'" [label]="''" [placeHolderVal]="'Saved Search Name'" [width]="'95%'"></app-st-input-text>
      <br>
    </div>
    <div class="modal-footer">
      <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
        <app-st-button-white [idVal]="'saved-search-modal-save-button-id'" [label]="'Save'" [primary]="true"
                       (click)="this.onSearch(true)"></app-st-button-white>
        <app-st-button-white [idVal]="'saved-search-modal-close-button-id'" [label]="'Close'" [primary]="false"
                        (click)="this.closeSavedSearchModal()"></app-st-button-white>
      </div>
    </div>
  </div>
</div>

<div id="mySidenav" class="sidenav">
  <a href="javascript:void(0)" class="closebtn" (click)="closeNav()">&times;</a>
  <app-st-header-title [inputVal]="'Search Filters'" [color]="'#FFFFFF'"></app-st-header-title>
  <div *ngIf="!this.platform.includes('android') && !this.platform.includes('iphone')" class="container st-form">
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end sidenavExtButton">
      <app-st-button *ngIf="!this.isSideNavOpened" [idVal]="'sidenav-ext-button-id'" [label]="'< Search Filters'" [primary]="true"
                     (click)="toggle()"></app-st-button>
    </div>
  </div>
  <div class="container st-form">
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button-white [idVal]="'reset-filters-modal-button1-id'" [label]="'Reset Filters'" [primary]="false"
                     (click)="resetAllFiltersModal()"></app-st-button-white>
      <app-st-button-white [idVal]="'saved-search-modal-button1-id'" [label]="'Save'" [primary]="false"
                     (click)="openSavedSearchModal()"></app-st-button-white>
      <app-st-button-white [idVal]="'top-search-button-id'" [label]="'Search'" [primary]="true"
                     (click)="this.onSearch(false)"></app-st-button-white>
    </div>
  </div>
  <div *ngIf="showSideNavErrorMessages" class="container st-form text-danger" #goUp>
    <br>
    <app-st-span [inputVal]="'Please validate the following: '"></app-st-span>
    <div *ngFor="let errorMsg of sideNavErrorMessages" class="alert alert-danger" role="alert">
      <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
    </div>
    <br>
  </div>
  <div *ngIf="showSideNavSuccessMessages" class="container st-form text-danger" #goUp>
    <div *ngFor="let successMsg of sideNavSuccessMessages" class="alert alert-success" role="alert">
      <b>{{successMsg.field}}:</b> {{successMsg.detail}}
    </div>
    <br>
  </div>
  <br>
  <!--https://getbootstrap.com/docs/4.0/components/modal/-->
  <!--Modal for saving the saved search-->

  <app-st-select [idVal]="'saved-search-selector-id'" [defaultOption]="'Select Saved Search'" [label]="''" [idKey]="'savedSearchId'" [displayKey]="'savedSearchName'" [valueKey]="'savedSearchId'" [inputArray]="this.savedSearchArray" ></app-st-select>
  <br>
  <app-st-button-white [idVal]="'top-apply-saved-search-button-id'" [label]="'Apply Saved Search'" [primary]="true"
                 (click)="this.onApplySavedSearch()"></app-st-button-white>
  <br>
  <br>
  <app-st-span [inputVal]="'Include Nonprofit Names: '"></app-st-span><br><app-st-span [inputVal]="'Include Name\'s legal name and accuracy are important. Separate multiple nonprofit names by commas.'"></app-st-span>
  <!--<app-st-input-text [idVal]="'name-with-text-id'" [label]="''" [placeHolderVal]="'Include Nonprofit Names'" [maxLength]="200" [width]="'95%'"></app-st-input-text>-->
  <app-st-autocomplete [idVal]="'name-with-text-id'" [label]="''" [placeHolderVal]="'Include Nonprofit Names'" [maxLength]="200" [width]="'95%'"
                       [items]="this.companyNamesAutocomplete"
  ></app-st-autocomplete>
  <!--
  <app-st-span [inputVal]="'Exclude Nonprofit Names: '"></app-st-span><app-st-span [inputVal]="'Separate multiple excluded nonprofit names by commas.'"></app-st-span><br>
  <app-st-input-text [idVal]="'name-without-text-id'" [label]="''" [placeHolderVal]="'Exclude Nonprofit Names'" [width]="'95%'"></app-st-input-text>
  -->
  <br>
  <app-st-span [inputVal]="'EIN: '"></app-st-span>
  <app-st-input-text [idVal]="'ein-text-id'" [label]="''" [placeHolderVal]="'EIN'" [maxLength]="20" [width]="'95%'"></app-st-input-text>
  <br>
  <div>
    <input class="form-check-input radio-button-properties" type="radio" value="'true'" id="flexRadioIncludeRevocationList"
           (click)="toggleRevokeLogicalExpression()" [checked]="includeTaxExemptRevoked">
    <label class="form-check-label checkbox-text webtext-black" for="flexRadioIncludeRevocationList">
      &nbsp;Include Nonprofits that are Tax Exempt Default
    </label>
  </div>
  <br>
  <app-st-span [inputVal]="'Include Cities: '"></app-st-span><app-st-span [inputVal]="'Separate multiple cities by commas.'"></app-st-span>
  <!--<app-st-input-text [idVal]="'cities-text-id'" [label]="''" [placeHolderVal]="'Include Cities'" [maxLength]="200" [width]="'95%'"></app-st-input-text>-->
  <app-st-autocomplete-key-lookup [idVal]="'cities-text-id'" [label]="''" [placeHolderVal]="'Include Cities'" [maxLength]="200" [width]="'95%'" [keyLookup]="'city'"
                                  [items]="this.citiesAutocomplete"
  ></app-st-autocomplete-key-lookup>
  <br>
  <!--
  <app-st-span [inputVal]="'Exclude Cities: '"></app-st-span><app-st-span [inputVal]="'Separate multiple cities by commas.'"></app-st-span>
  <app-st-input-text [idVal]="'cities-without-text-id'" [label]="''" [placeHolderVal]="'Exclude Cities'" [maxLength]="200" [width]="'95%'"></app-st-input-text>
  <br>-->
  <app-st-span [inputVal]="'State: '"></app-st-span><br>
  <app-st-select [idVal]="'usa-dropdown-list-id'" [defaultOption]="'Select State'" [label]="''" [idKey]="'usaStateId'" [displayKey]="'usaState'" [valueKey]="'usaState'" [inputArray]="this.statesList"></app-st-select>
  <br>
  <app-st-span [inputVal]="'Zip Code: '"></app-st-span>
  <app-st-input-text [idVal]="'zip-code-text-id'" [label]="''" [placeHolderVal]="'Zip Code'" [maxLength]="20" [width]="'95%'"></app-st-input-text>
  <!--
  <app-st-span [inputVal]="'Include Counties: '"></app-st-span><app-st-span [inputVal]="'Separate multiple included counties by commas.'"></app-st-span><br>
  <app-st-input-text [idVal]="'counties-text-id'" [label]="''" [placeHolderVal]="'Include Counties'" [width]="'95%'"></app-st-input-text>
  <app-st-span [inputVal]="'Exclude Counties: '"></app-st-span><app-st-span [inputVal]="'Separate multiple excluded counties by commas.'"></app-st-span><br>
  <app-st-input-text [idVal]="'counties-without-text-id'" [label]="''" [placeHolderVal]="'Exclude Counties'" [width]="'95%'"></app-st-input-text>
  -->
  <!--
  <br>
  <app-st-span [inputVal]="'Minimum Number of Years In Business: '" class="webtext-black-bold"></app-st-span>
  <app-st-input-text [idVal]="'min-years-in-business-text-id'" [label]="''" [placeHolderVal]="'Minimum Number of Years In Business'" [maxLength]="6" [width]="'95%'"></app-st-input-text>
  -->
  <br>

  <!--Cause Dropdown triggers the Giving Interest Dropdown-->
  <app-st-span [inputVal]="'Cause Category: '" class="webtext-black-bold"></app-st-span>
  <app-st-select [idVal]="'cause-category-dropdown-list-id'" [defaultOption]="'Cause Category'" [label]="''" [idKey]="'causeId'" [displayKey]="'causeDisplayName'" [valueKey]="'causeName'" [inputArray]="this.causeDropdownList" (change)="updateCauseGivingInterestsDropdown()"></app-st-select>
  <br>
  <app-st-span [inputVal]="'Select the option of your search for the selected Cause Category Giving Interest: '" class="webtext-black-bold"></app-st-span>
  <div>
    <input class="form-check-input radio-button-properties" type="radio" value="'AND'" id="flexRadioAND3"
           (click)="trackLogicalExpression('AND')" [checked]="logicalOperatorAnd">
    <label class="form-check-label checkbox-text webtext-black" for="flexRadioAND3">
      &nbsp;AND
    </label>
    &nbsp;&nbsp;
    <input class="form-check-input radio-button-properties" type="radio" value="'OR'" id="flexRadioOR3"
           (click)="trackLogicalExpression('OR')" [checked]="logicalOperatorOr">
    <label class="form-check-label checkbox-text webtext-black" for="flexRadioOR3">
      &nbsp;OR
    </label>
  </div>
  <br>

  <!--Giving Interest Dropdown-->
  <app-st-span [inputVal]="'Cause Category Giving Interests: '" class="webtext-black-bold"></app-st-span>
  <app-st-select [idVal]="'cause-giving-interests-dropdown-list-id'" [defaultOption]="'Select your Cause Category Giving Interests'" [label]="''" [idKey]="'causeGivingInterestId'" [displayKey]="'givingInterestDisplayName'" [valueKey]="'givingInterestName'" [inputArray]="this.causeGivingInterestsDropdownList"></app-st-select>
  <br>
  <div class="col2 d-grid gap-2 d-md-flex">
    <app-st-button-white [idVal]="'cause-giving-interests-include-button-id'" [label]="'Add (+)'" [primary]="true"
                   (click)="this.addCauseGivingInterestFilter2(true)"></app-st-button-white>
  </div>
  <!--Include these cause_giving_interests-->
  <br>
  <i class="webtext-black" style="font-size: 12px;">As you add your Cause Category Giving Interests, the list below will populate.</i>
  <div>
    <table class="table table-striped webtext-black" style="width:95%; border-radius: 10px">
      <thead>
      <tr>
        <th style="width:85%">Cause Category Giving Interests Query</th>
        <th style="width:15%">Action</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let row of this.causeGivingInterestsList">
        <td>{{row}}</td>
        <td>
          <a *ngIf="('OR' != row) && ('AND' != row)" (click)="onDeleteGivingInterest(row)">
            <i class="bi bi-trash"></i>
          </a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <br><br>
  <div>
    <button id="'advanced-filters-button-id'" class="accordionParent webtext-black" (click)="this.toggleAdvancedFilters()"><b>Advanced Filters </b> <b *ngIf="!this.advancedFiltersButton">(Click to expand) + </b><b *ngIf="this.advancedFiltersButton">(Click to collapse) - </b></button>
    <br>
  </div>
  <div *ngIf="this.advancedFiltersButton" class="panel">
    <br>
    <!--
    <div>
      <button id="'filing-req-codes-button-id'" class="accordion" (click)="this.toggleFilingReqCodesFilter()">Filing Req Codes <b *ngIf="!this.filingReqCodeButton"> + </b><b *ngIf="this.filingReqCodeButton"> - </b></button>
    </div>
    <div *ngIf="this.filingReqCodeButton" class="panel">
      <div class="accordion-body" *ngFor="let filingReqCodeCheckbox of filingReqCodeCheckboxes; let i5 = index">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" value="{{filingReqCodeCheckbox['filingReqCodeId']}}" id="flexCheckCheckedFilingReqCode-{{i5}}"
                 (click)="addValToFilingReqCodes(i5)" [checked]="filingReqCodeCheckbox['checked']">
          <label class="form-check-label checkbox-text" for="flexCheckCheckedFilingReqCode-{{i5}}">
            {{filingReqCodeCheckbox['description']}}
          </label>
        </div>
      </div>
    </div>-->
  <!--
    <div>
      <button id="'foundation-codes-button-id'" class="accordion" (click)="this.toggleFoundationCodesFilter()">Foundation Codes <b *ngIf="!this.foundationCodeButton"> + </b><b *ngIf="this.foundationCodeButton"> - </b></button>
    </div>
    <div *ngIf="this.foundationCodeButton" class="panel">
      <div class="accordion-body" *ngFor="let foundationCodeCheckbox of foundationCodeCheckboxes; let i5 = index">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" value="{{foundationCodeCheckbox['foundationCodeId']}}" id="flexCheckCheckedFoundationCode-{{i5}}"
                 (click)="addValToFoundationCodes(i5)" [checked]="foundationCodeCheckbox['checked']">
          <label class="form-check-label checkbox-text" for="flexCheckCheckedFoundationCode-{{i5}}">
            {{foundationCodeCheckbox['description']}}
          </label>
        </div>
      </div>
    </div>-->

    <div>
      <button id="'ntee-codes-button-id'" class="accordion" (click)="this.toggleNteeCodesFilter()"><b>NTEE Codes</b> <b *ngIf="!this.nteeCodeButton"> (Click to expand) + </b><b *ngIf="this.nteeCodeButton"> (Click to collapse) - </b></button>
    </div>
    <div *ngIf="this.nteeCodeButton" class="panel">
      <div class="accordion-body" *ngFor="let nteeCodeCheckbox of nteeCodeCheckboxes; let i6 = index">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" value="{{nteeCodeCheckbox['nteeCodeId']}}" id="flexCheckCheckedNteeCode-{{i6}}"
                 (click)="addValToNteeCodes(i6)" [checked]="nteeCodeCheckbox['checked']">
          <label class="form-check-label checkbox-text" for="flexCheckCheckedNteeCode-{{i6}}">
           {{nteeCodeCheckbox['nteeCode']}}: {{nteeCodeCheckbox['description']}}
          </label>
        </div>
      </div>
      <div>
        <app-st-button-white *ngIf="this.nteeCodeButton" [idVal]="'see-less-ntee-codes-button-id'" [label]="'^ See Less'" [primary]="true"
                             (click)="this.toggleNteeCodesFilter()"></app-st-button-white>
      </div>
    </div>
    <br>
    <div>
      <button id="'ntee-parent-codes-button-id'" class="accordion" (click)="this.toggleNteeParentCodesFilter()"><b>NTEE Parent Codes</b> <b *ngIf="!this.nteeParentCodeButton"> (Click to expand) + </b><b *ngIf="this.nteeParentCodeButton"> (Click to collapse) - </b></button>
    </div>
    <div *ngIf="this.nteeParentCodeButton" class="panel">
      <div class="accordion-body" *ngFor="let nteeParentCodeCheckbox of nteeParentCodeCheckboxes; let i7 = index">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" value="{{nteeParentCodeCheckbox['nteeParentCodeId']}}" id="flexCheckCheckedNteeParentCode-{{i7}}"
                 (click)="addValToNteeParentCodes(i7)" [checked]="nteeParentCodeCheckbox['checked']">
          <label class="form-check-label checkbox-text" for="flexCheckCheckedNteeParentCode-{{i7}}">
            {{nteeParentCodeCheckbox['description']}}
          </label>
        </div>
      </div>
      <div>
        <app-st-button-white *ngIf="this.nteeParentCodeButton" [idVal]="'see-less-ntee-parent-codes-button-id'" [label]="'^ See Less'" [primary]="true"
                             (click)="this.toggleNteeParentCodesFilter()"></app-st-button-white>
      </div>
    </div>
    <br>
    <div>
      <button id="'organization-codes-button-id'" class="accordion" (click)="this.toggleOrganizationCodesFilter()"><b>Organization Codes</b> <b *ngIf="!this.organizationCodeButton"> (Click to expand) + </b><b *ngIf="this.organizationCodeButton"> (Click to collapse) - </b></button>
    </div>
    <div *ngIf="this.organizationCodeButton" class="panel">
      <div class="accordion-body" *ngFor="let organizationCodeCheckbox of organizationCodeCheckboxes; let i8 = index">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" value="{{organizationCodeCheckbox['organizationCodeId']}}" id="flexCheckCheckedOrganizationCode-{{i8}}"
                 (click)="addValToOrganizationCodes(i8)" [checked]="organizationCodeCheckbox['checked']">
          <label class="form-check-label checkbox-text" for="flexCheckCheckedFoundationCode-{{i8}}">
            {{organizationCodeCheckbox['description']}}
          </label>
        </div>
      </div>
      <div>
        <app-st-button-white *ngIf="this.organizationCodeButton" [idVal]="'see-less-organization-codes-button-id'" [label]="'^ See Less'" [primary]="true"
                             (click)="this.toggleOrganizationCodesFilter()"></app-st-button-white>
      </div>
    </div>
    <br>
  <!--
    <div>
      <button id="'return-type-codes-button-id'" class="accordion" (click)="this.toggleReturnTypeCodesFilter()">Return Type Codes <b *ngIf="!this.returnTypeCodeButton"> + </b><b *ngIf="this.returnTypeCodeButton"> - </b></button>
    </div>
    <div *ngIf="this.returnTypeCodeButton" class="panel">
      <div class="accordion-body" *ngFor="let returnTypeCodeCheckbox of returnTypeCodeCheckboxes; let i9 = index">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" value="{{returnTypeCodeCheckbox['returnTypeCodeId']}}" id="flexCheckCheckedReturnTypeCode-{{i9}}"
                 (click)="addValToReturnTypeCodes(i9)" [checked]="returnTypeCodeCheckbox['checked']" [disabled]="true">
          <label class="form-check-label checkbox-text" for="flexCheckCheckedReturnTypeCode-{{i9}}">
            {{returnTypeCodeCheckbox['returnTypeCodeName']}}
          </label>
        </div>
      </div>
    </div>-->
  </div>
  <br>
  <div>
    <app-st-span [inputVal]="'Sort By Organization: '" class="webtext-black-bold"></app-st-span>
    <div>
      <input class="form-check-input radio-button-properties" type="radio" value="false" id="company-name-asc-radio-button-id"
             (click)="toggleCompanyNameAscButton()" [checked]="this.companyNameAscRadioButton">
      <label class="form-check-label checkbox-text webtext-black" for="company-name-asc-radio-button-id">
        &nbsp;ASCENDING
      </label>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <input class="form-check-input radio-button-properties" type="radio" value="false" id="company-name-desc-radio-button-id"
             (click)="toggleCompanyNameDescButton()" [checked]="this.companyNameDescRadioButton">
      <label class="form-check-label checkbox-text webtext-black" for="company-name-desc-radio-button-id">
        &nbsp;DESCENDING
      </label>
    </div>
  </div>
  <br>
  <div>
    <app-st-span [inputVal]="'Sort By City: '" class="webtext-black-bold"></app-st-span>
    <div>
      <input class="form-check-input radio-button-properties" type="radio" value="false" id="city-asc-radio-button-id"
             (click)="toggleCityAscButton()" [checked]="this.cityAscRadioButton">
      <label class="form-check-label checkbox-text webtext-black" for="city-asc-radio-button-id">
        &nbsp;ASCENDING
      </label>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <input class="form-check-input radio-button-properties" type="radio" value="false" id="city-desc-radio-button-id"
             (click)="toggleCityDescButton()" [checked]="this.cityDescRadioButton">
      <label class="form-check-label checkbox-text webtext-black" for="city-desc-radio-button-id">
        &nbsp;DESCENDING
      </label>
    </div>
  </div>
  <br>
  <div>
    <app-st-span [inputVal]="'Sort By State: '" class="webtext-black-bold"></app-st-span>
    <div>
      <input class="form-check-input radio-button-properties" type="radio" value="false" id="state-asc-radio-button-id"
             (click)="toggleStateAscButton()" [checked]="this.stateAscRadioButton">
      <label class="form-check-label checkbox-text webtext-black" for="state-asc-radio-button-id">
        &nbsp;ASCENDING
      </label>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <input class="form-check-input radio-button-properties" type="radio" value="false" id="state-desc-radio-button-id"
             (click)="toggleStateDescButton()" [checked]="this.stateDescRadioButton">
      <label class="form-check-label checkbox-text webtext-black" for="state-desc-radio-button-id">
        &nbsp;DESCENDING
      </label>
    </div>
  </div>
  <br>
  <div>
    <app-st-span [inputVal]="'Sort By Total Assets: '" class="webtext-black-bold"></app-st-span>
    <div>
      <input class="form-check-input radio-button-properties" type="radio" value="false" id="total-assets-asc-radio-button-id"
             (click)="toggleTotalAssetsAscButton()" [checked]="this.totalAssetsAscRadioButton">
      <label class="form-check-label checkbox-text webtext-black" for="total-assets-asc-radio-button-id">
        &nbsp;ASCENDING
      </label>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <input class="form-check-input radio-button-properties" type="radio" value="false" id="total-assets-desc-radio-button-id"
             (click)="toggleTotalAssetsDescButton()" [checked]="this.totalAssetsDescRadioButton">
      <label class="form-check-label checkbox-text webtext-black" for="total-assets-desc-radio-button-id">
        &nbsp;DESCENDING
      </label>
    </div>
  </div>
  <br>
  <br>
  <div class="container st-form">
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button-white [idVal]="'reset-filters-modal-button2-id'" [label]="'Reset Filters'" [primary]="false"
                     (click)="resetAllFiltersModal()"></app-st-button-white>
      <app-st-button-white [idVal]="'saved-search-modal-button2-id'" [label]="'Save'" [primary]="false"
                     (click)="openSavedSearchModal()"></app-st-button-white>
      <app-st-button-white [idVal]="'bottom-search-button-id'" [label]="'Search'" [primary]="true"
                     (click)="this.onSearch(false)"></app-st-button-white>
    </div>
  </div>
  <br>
  <div *ngIf="showSideNavErrorMessages" class="container st-form text-danger" #goUp>
    <br>
    <app-st-span [inputVal]="'Please validate the following: '"></app-st-span>
    <div *ngFor="let errorMsg of sideNavErrorMessages" class="alert alert-danger" role="alert">
      <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
    </div>
    <br>
  </div>
  <br>
  <div class="container st-form">
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <a href="javascript:void(0)" class=".closebtn-bottom" (click)="closeNav()">&times;</a>
    </div>
  </div>
  <br>
</div>

<app-st-banner [idVal]="'banner-id'" [breadCrumbs]="this.breadCrumbs"
               [hasElementTags]="false" [elementTags]="[]" [requiresSignOutButton]="true"
></app-st-banner>
<br><br><br><br><br>
<div class="container-xxl">
    <div class="row pt-4 pb5">
      <div class="col-2 d-flex justify-content-center neg-margin">
        <!--<app-st-profile-picture></app-st-profile-picture>-->
      </div>
      <div class="col-8">
        <app-st-header-title [inputVal]="pageName"></app-st-header-title>
        <br>
        <div *ngIf="showPageErrorMessages" class="container st-form text-danger" #goUp>
          <app-st-span [inputVal]="'Please validate the following: '"></app-st-span>
          <div *ngFor="let errorMsg of pageErrorMessages" class="alert alert-danger" role="alert">
            <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
          </div>
          <br>
        </div>
        <div *ngIf="showPageSuccessMessages" class="container st-form text-success" #goUp>
          <div *ngFor="let successMsg of pageSuccessMessages" class="alert alert-success" role="alert">
            <b>{{successMsg.field}}:</b> {{successMsg.detail}}
          </div>
          <br>
        </div>
        <br>
        <!--<span style="font-size:30px;cursor:pointer" (click)="openNav()">&#9776; Filters</span>-->
        <app-st-button-filter [idVal]="'filter-button-id'" [label]="'Search Filters'"
                              (click)="this.openNav()"></app-st-button-filter>
        &nbsp;&nbsp;
        <app-st-button-delete-all [idVal]="'clear-results-button-id'" [label]="'Clear Results'"
                                  (click)="this.clearResultsAndFilter()"></app-st-button-delete-all>
        <br>
        <br>

        <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
          <app-st-button *ngIf="(this.subscriptionActive && !this.customerTrialVerified)"
            [idVal]="'top-export-to-excel-button-id'" [label]="'Download Your Results to CSV'" [primary]="true"
                         (click)="this.onExportToExcel()"
          ></app-st-button>
        </div>
        <app-st-pagination2 [idVal]="'search-nonprofits-pagination-id'" [collectionSize]="this.collectionSize"
                            [currentPage]="this.page" [pageSize]="100" [maxPagesDisplayed]="7"
                            [customPageSizes]="this.customPageSizes"
                            (pageChange)="changePageResults($event)" #nonprofitspaginator
        ></app-st-pagination2>

        <table class="table table-striped webtext-black"  *ngIf="!loadingIcon; else loadingPage">
          <thead>
          <tr>
            <th style="width:35%">Organization
              <app-st-button-sort-text-asc *ngIf="this.sortedAscCityHeaderButton" [idVal]="'sort-company-name-asc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextCompanyName()">

              </app-st-button-sort-text-asc>
              <app-st-button-sort-text-desc *ngIf="!this.sortedAscCityHeaderButton" [idVal]="'sort-company-name-desc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextCompanyName()">

              </app-st-button-sort-text-desc>
            </th>
            <th style="width:15%">EIN</th>
            <th style="width:15%">City
              <app-st-button-sort-text-asc *ngIf="this.sortedAscCityHeaderButton" [idVal]="'sort-city-asc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextCity()">

              </app-st-button-sort-text-asc>
              <app-st-button-sort-text-desc *ngIf="!this.sortedAscCityHeaderButton" [idVal]="'sort-city-desc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextCity()">

              </app-st-button-sort-text-desc>
            </th>
            <th style="width:15%">State
              <app-st-button-sort-text-asc *ngIf="this.sortedAscStateHeaderButton" [idVal]="'sort-state-asc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextState()">

              </app-st-button-sort-text-asc>
              <app-st-button-sort-text-desc *ngIf="!this.sortedAscStateHeaderButton" [idVal]="'sort-state-desc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextState()">

              </app-st-button-sort-text-desc>
            </th>
            <th style="width:15%">Zip Code</th>
            <th style="width:15%">Total Assets
              <app-st-button-sort-number-asc *ngIf="this.sortedAscTotalAssetsHeaderButton" [idVal]="'sort-total-assets-asc-button-id'" [label]="''" [primary]="false" (click)="this.sortNumberTotalAssets()">

              </app-st-button-sort-number-asc>
              <app-st-button-sort-number-desc *ngIf="!this.sortedAscTotalAssetsHeaderButton" [idVal]="'sort-total-assets-desc-button-id'" [label]="''" [primary]="false" (click)="this.sortNumberTotalAssets()">

              </app-st-button-sort-number-desc>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let row of rows">
            <td>{{row['companyName']}}&nbsp;<i class="bi bi-search btn" (click)="onViewDetails(row)"></i></td>
            <td>{{this.formatEin(row['ein'])}}</td>
            <td>{{row['taxFilingCity']}}</td>
            <td>{{row['taxFilingState']}}</td>
            <td>{{this.formatZip(row['taxFilingZipCode'])}}</td>
            <td>{{row['totalAssetsFormatted']}}</td>
          </tr>
          </tbody>
        </table>
        <br>
        <app-st-button-back-to-top></app-st-button-back-to-top>
        <br>
        <br>
        <ng-template #loadingPage >
          <div class="d-flex justify-content-center">
            <br>
            <br>
            <div class="spinner-grow text-info" role="status">
              <span class="visually-hidden webtext-black">Loading...</span>
            </div>
          </div>
        </ng-template>
    </div>
    </div>
</div>
<br><br><br>
